/** @jsxImportSource @emotion/react */
import LinearLoading from 'components/atoms/LinearLoading'
import React from 'react'

export const BillingLoading = () => (
  <div
    css={{
      height: 50,
      padding: '0 100px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '.progress': {
        borderRadius: '3px !important',
        boxShadow: '-1px 8px 11px -1px rgba(226, 226, 226, 1) !important',
      },
    }}>
    <LinearLoading />
  </div>
)
